"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtil_1 = __importDefault(require("./StringUtil"));
var eq_1 = __importDefault(require("lodash/eq"));
var PropertiesUtil = /** @class */ (function () {
    function PropertiesUtil() {
    }
    PropertiesUtil.parseObject = function (obj) {
        var values = [];
        if (StringUtil_1.default.isString(obj)) {
            values.push(obj);
        }
        else {
            var keys = Object.keys(obj);
            keys.forEach(function (key) {
                var parsedKeys = PropertiesUtil.parseObject(obj[key]);
                parsedKeys.forEach(function (parsedKey) {
                    console.log('parsedKey', parsedKey);
                    if (parsedKey.includes(' = ')) {
                        if (parsedKey.startsWith(' = ')) {
                            values.push(key + parsedKey);
                        }
                        else {
                            values.push(key + '.' + parsedKey);
                        }
                    }
                    else {
                        values.push(key + ' = ' + parsedKey);
                    }
                });
            });
        }
        return values;
    };
    PropertiesUtil.stringify = function (obj) {
        var values = PropertiesUtil.parseObject(obj);
        return values.join('\n');
    };
    PropertiesUtil.eq = function (source, target) {
        return eq_1.default(source, target);
    };
    return PropertiesUtil;
}());
exports.default = PropertiesUtil;
//# sourceMappingURL=PropertiesUtil.js.map